import PropTypes from 'prop-types';

import { Button, Form, Input } from 'antd';
import ToastMessage from '@/utils/toastMessage/ToastMessage';
import { AntButton } from '@/common/ant-components/AntButton';
import { LockOutlined, SafetyOutlined, UserOutlined } from '@ant-design/icons';

const AdminLogin = ({
  validateMobileNumber,
  firstInputRef,
  loading,
  handleLogin,
}) => {
  return (
    <>
      <ToastMessage />
      <div className="admin-badge">
        <SafetyOutlined /> Admin Access
      </div>
      <Form
        initialValues={{ remember: true }}
        onFinish={(value) => {
          const { mobileNumber, password } = value;

          const trimmedMobileNumber = mobileNumber
            ?.replace(/[\u202C\u200B-\u200F\uFEFF]/g, '')
            ?.trim();

          const trimmedPassword = password
            ?.replace(/[\u202C\u200B-\u200F\uFEFF]/g, '')
            ?.trim();

          handleLogin('admin/login/', {
            mobileNumber: trimmedMobileNumber,
            password: trimmedPassword,
          });
        }}
        className="modern-login-form"
        layout="vertical"
      >
        <Form.Item
          name="mobileNumber"
          label={<span className="form-label">Username</span>}
          className="username"
          validateTrigger="onChange"
          rules={[
            {
              required: true,
              message: 'Please input your admin username!',
            },
          ]}
        >
          <Input
            // maxLength={10}
            ref={firstInputRef}
            placeholder="Enter admin username"
            prefix={<UserOutlined className="input-icon" />}
            size="large"
            className="modern-input"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label={<span className="form-label">Password</span>}
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password
            type="password"
            placeholder="Enter admin password"
            prefix={<LockOutlined className="input-icon" />}
            className="modern-input"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, marginTop: '12px' }}>
          <AntButton
            className="modern-submit-button"
            htmlType="submit"
            disabled={loading}
            block
            size="large"
          >
            {loading ? 'Signing in...' : 'Admin Sign In'}
          </AntButton>
        </Form.Item>
      </Form>
    </>
  );
};

AdminLogin.propTypes = {
  navigate: PropTypes.func,
  firstInputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  validateMobileNumber: PropTypes.func,
  loading: PropTypes.bool,
  handleLogin: PropTypes.func,
};

export default AdminLogin;
